import apiUtils from "./apiUtils";

const fetchSectorsWithProjects = async () => {
    return apiUtils.get(
        '/api/sectors/with-projects', 
        'Не удалось получить информацию о проектах'
    );
};

const updateSector = async (sectorId, sectorData) => {
    return apiUtils.put(
        `/api/sectors/${sectorId}`,
        sectorData,
        'Ошибка при обновлении сектора'
    );
};

export default { fetchSectorsWithProjects, updateSector };